import { Button, Card, DynamicLink, Flex } from "@capioweb/ui-components/src"
import ContentLink from "../../@types/EpiFoundationSpa/Models/ContentLink"
import {
	ContentReferenceProperty,
	LinkProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { assetBaseUrl } from "../../utils"
import { BlockCommonLayout } from "../../utils/layout"

interface PressAssetCardProps {
	heading: StringProperty
	previewImage: StringProperty
	mediaFile: ContentReferenceProperty
	imagePosition: StringProperty
	contentLink: ContentLink
	publishedDate: StringProperty
	alternateText: StringProperty
	fileName: StringProperty
}

interface PressAssetListingBlockProps {
	heading: StringProperty
	ctaLink: LinkProperty
	assets: PressAssetCardProps[]
}

const AssetCard: React.FC<PressAssetCardProps> = (props) => {
	return (
		<Card
			w="100%"
			h={48.5}
			media={
				<>
					{props.mediaFile?.value?.url && (
						<img
							src={`${assetBaseUrl()}${
								props.mediaFile?.value?.url
							}?w=800&scale=down&format=webp`}
							alt={props.alternateText?.value}
							loading="lazy"
							style={
								props.imagePosition?.value === "center top"
									? { objectPosition: "center top" }
									: null
							}
						/>
					)}
				</>
			}
			borderColor="blue33"
		>
			<Card.DateLine>{props.publishedDate.value ?? ""}</Card.DateLine>
			<Card.TitleNews>
				{props.heading.value !== ""
					? props.heading.value
					: props.fileName.value}
			</Card.TitleNews>
		</Card>
	)
}

const PressAssetListingBlock: React.FC<PressAssetListingBlockProps> = ({
	assets,
	heading,
	ctaLink,
}) => {
	return (
		assets?.length > 0 && (
			<BlockCommonLayout heading={heading}>
				<Flex
					w={1}
					flexWrap="wrap"
					justifyContent="flex-start"
					alignContent="space-between"
					columnGap={{ m: 3 }}
					rowGap={{ _: 2, m: 3 }}
					mb={{ _: 2, m: 3 }}
				>
					{assets.map((c, i) => {
						return (
							<Flex
								key={`assetsPage${i}`}
								w={1}
								flexShrink={1}
								flexGrow={0}
								flexBasis={{
									_: "100%",
									m: "calc(50% - 12px)",
									l: "calc(100% / 3 - 16px)",
								}}
								px={0}
							>
								{c.contentLink?.url && (
									<DynamicLink url={c.contentLink.url ?? "#"}>
										<AssetCard {...c} />
									</DynamicLink>
								)}
							</Flex>
						)
					})}
				</Flex>

				<Button.Link
					variant="ghost"
					to={ctaLink?.href ?? "#"}
					target={ctaLink?.target}
				>
					{ctaLink?.text ?? ""}
				</Button.Link>
			</BlockCommonLayout>
		)
	)
}

export { PressAssetListingBlock }
